import type React from "react";
import { ReactComponent as Svg } from "./assets/result.svg";
import * as styles from "./Icon.module.scss";

type ResultProps = React.SVGProps<SVGSVGElement>;

export const Result = ({ className, ...props }: ResultProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
